module.exports = __webpack_public_path__ + "static/img/inv-2.9fc9ba2.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/inv-2.png
// module id = Vwtx
// module chunks = 0